import React, { useEffect, useRef, useState } from 'react';
import { MOVE_FOLDERS } from '../utils/moveMail';
import './labels/labels.css';

const toolbarIcon = (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />
    <polyline points="14 12 18 12 18 16" />
  </svg>
);

const headerIcon = (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M10 4H4c-1.11 0-2 .89-2 2v12c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2h-8l-2-2z" />
  </svg>
);

const MoveToFolderButton = ({
  currentFolder = '',
  onMove,
  className = 'toolbar-btn',
  variant = 'toolbar',
}) => {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);
  const busyRef = useRef(false);
  const folders = MOVE_FOLDERS.filter((folder) => folder.id !== currentFolder);

  useEffect(() => {
    if (!open) return undefined;
    const close = (event) => {
      if (!wrapRef.current?.contains(event.target)) setOpen(false);
    };
    const onKey = (event) => {
      if (event.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', close);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', close);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  const choose = async (folderId) => {
    if (busyRef.current) return;
    busyRef.current = true;
    setOpen(false);
    try {
      await onMove?.(folderId);
    } finally {
      busyRef.current = false;
    }
  };

  return (
    <div className="move-folder-wrap" ref={wrapRef}>
      <button
        type="button"
        className={className}
        title="Move to folder"
        aria-label="Move to folder"
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={(event) => {
          event.stopPropagation();
          setOpen((value) => !value);
        }}
      >
        {variant === 'header' ? headerIcon : toolbarIcon}
      </button>
      {open && (
        <div className="label-selector move-folder-menu" role="menu" aria-label="Move to folder">
          <div className="label-selector-title">Move to</div>
          {folders.map((folder) => (
            <button
              key={folder.id}
              type="button"
              className="label-selector-item"
              role="menuitem"
              onClick={(event) => {
                event.stopPropagation();
                choose(folder.id);
              }}
            >
              <span>{folder.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default MoveToFolderButton;
